import { faUser, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Pagination from '../../Pagination';
import GlobalSettingsHRByAdmin from './GlobalSettingsHRByAdmin';
import { toast, ToastContainer } from 'react-toastify';
import { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DashboardLayout from './DashboardLayout';

const GlobalSettings = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;

    const [key, setKey] = useState('candidate');
    const [allUsers, setAllUsers] = useState([]);
    const [candidates, setCandidates] = useState([]);
    const [hrUsers, setHrUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedUserName, setSelectedUserName] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [globalCandidateSettings, setGlobalCandidateSettings] = useState(null);
    const [totalApplications, setTotalApplications] = useState(0);

    // Pagination & Sorting
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [totalPages, setTotalPages] = useState(0);
    const [sortedColumn, setSortedColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');
    const handlePageClick = (data) => {
        setPage(data.selected);
    };
    const handlePageSizeChange = (e) => {
        const size = parseInt(e.target.value);
        setPageSize(size);
        setPage(0); // Reset page when page size changes
    };
    const isLastPage = page === totalPages - 1;
    const isPageSizeDisabled = isLastPage;
    const fetchUsers = async (key) => {
        try {
            const params = {
                page,
                size: pageSize,
                sortBy: sortedColumn,
                sortOrder: sortOrder,
            };
            if (key === 'candidate') {
                const response = await axios.get(`${BASE_API_URL}/displayAllCandidate`, { params });
                const users = response.data.content;
                setTotalPages(response.data.totalPages);
                setCandidates(users);
            } else {
                const response = await axios.get(`${BASE_API_URL}/displayAllHRs`, { params });
                const users = response.data.content;
                setHrUsers(users);
                setTotalPages(response.data.totalPages);
            }

        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsers(key);
    }, [page, pageSize, sortedColumn, sortOrder, key]);


    useEffect(() => {
        if (globalCandidateSettings) {
            const total =
                globalCandidateSettings.defaultApplicationPerDay +
                globalCandidateSettings.creditsBasedOnExprience *
                Math.max(globalCandidateSettings.totalYearsExprience - 1, 0) +
                globalCandidateSettings.additionalCreditsByUser;

            setTotalApplications(total);
        }
    }, [globalCandidateSettings]);
    const customTabHeader = (title, icon) => (
        <div className="d-flex align-items-center">
            <span className="me-2">{icon}</span>
            <span className="fs-6 fw-bold">{title}</span>
        </div>
    );

    const handleSort = (column) => {
        if (sortedColumn === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortedColumn(column);
            setSortOrder('asc');
        }
    };
    const handleAddClick = async (userId, userName) => {
        setSelectedUserName(userName);
        setSelectedUserId(userId);
        // Call any function here with the userId
       // console.log("User ID clicked:", userId);
        const params = {
            userId: userId
        };
        const response = await axios.get(`${BASE_API_URL}/getGlobalCandidateSettingsByUserId`, { params });
        setGlobalCandidateSettings(response.data)
        // Open the modal
        setShowModal(true);
    };
    const handleSaveChanges = async () => {
        try {
            const response = await axios.put(
                `${BASE_API_URL}/updateGlobalCandidateSettingsByUserId`,
                globalCandidateSettings,
                {
                    params: {
                        userId: selectedUserId,
                        totalApplications: totalApplications,
                    },
                }
            );
            if (response.data) {
                toast.success(`Updated successfully`);
                fetchUsers('candidate');
            }
            setShowModal(false);
        } catch (error) {
            console.error(error);
            alert('An error occurred while saving changes');
        }
    };

    const renderCandidateTable = (users) => (
        <>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th onClick={() => handleSort('userName')}>
                            User Name {sortedColumn === 'userName' && (sortOrder === 'asc' ? '▲' : '▼')}
                        </th>
                        <th onClick={() => handleSort('userRole')}>
                            User Role {sortedColumn === 'userRole' && (sortOrder === 'asc' ? '▲' : '▼')}
                        </th>
                        <th onClick={() => handleSort('userEmail')}>
                            User Email {sortedColumn === 'userEmail' && (sortOrder === 'asc' ? '▲' : '▼')}
                        </th>
                        <th onClick={() => handleSort('totalAppliedJobsPerDay')}>
                            Total Job apply per day {sortedColumn === 'totalAppliedJobsPerDay' && (sortOrder === 'asc' ? '▲' : '▼')}
                        </th>
                        <th>Add Additional</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user, index) => (
                        <tr key={user.userId}>
                            <td>{user.userName}</td>
                            <td>{user.userRole}</td>
                            <td>{user.userEmail}</td>
                            <td>{user.totalAppliedJobsPerDay}</td>
                            <td><Button onClick={() => handleAddClick(user.userId, user.userName)}>Add</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Pagination */}

            <Pagination
                page={page}
                pageSize={pageSize}
                totalPages={totalPages}
                handlePageSizeChange={handlePageSizeChange}
                isPageSizeDisabled={isPageSizeDisabled}
                handlePageClick={handlePageClick}
            />
        </>
    );
    const renderHRTable = (users) => (
        <>
          <GlobalSettingsHRByAdmin />
        </>
    );
    return (
        <DashboardLayout>
            {/* <div>GlobalSettings</div> */}
            <Row>
                <Col className='filter-action' style={{ paddingTop: '10px', marginLeft: '12px', marginRight: '12px' }}>
                    <Tabs
                        id="application-tabs"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                    >
                        <Tab eventKey="candidate" title={customTabHeader("Candidate Settings", <FontAwesomeIcon icon={faUser} />)}>
                            {candidates.length > 0 ? (
                                renderCandidateTable(candidates)
                            ) : (
                                <p>No candidate users found.</p>
                            )}
                        </Tab>

                        <Tab eventKey="hr" title={customTabHeader("HR Settings", <FontAwesomeIcon icon={faUserCheck} />)}>
                            {hrUsers.length > 0 ? (
                                renderHRTable(hrUsers)
                            ) : (
                                <p>No HR users found.</p>
                            )}
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Additional Details for {selectedUserName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {globalCandidateSettings ? (
                        <Table bordered>
                            <tbody>
                                <tr>
                                    <th>Default Applications Per Day</th>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            placeholder="Numbers only"
                                            value={globalCandidateSettings?.defaultApplicationPerDay || ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    setGlobalCandidateSettings((prev) => ({
                                                        ...prev,
                                                        defaultApplicationPerDay: value === '' ? '' : parseInt(value, 10),
                                                    }));
                                                }
                                            }}
                                            onPaste={(e) => {
                                                if (!/^\d+$/.test(e.clipboardData.getData('Text'))) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Credits Based On Experience</th>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            placeholder="Numbers only"
                                            value={globalCandidateSettings?.creditsBasedOnExprience || ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    setGlobalCandidateSettings((prev) => ({
                                                        ...prev,
                                                        creditsBasedOnExprience: value === '' ? '' : parseInt(value, 10),
                                                    }));
                                                }
                                            }}
                                            onPaste={(e) => {
                                                if (!/^\d+$/.test(e.clipboardData.getData('Text'))) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Additional Credits By User</th>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            placeholder="Numbers only"
                                            value={globalCandidateSettings?.additionalCreditsByUser || ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    setGlobalCandidateSettings((prev) => ({
                                                        ...prev,
                                                        additionalCreditsByUser: value === '' ? '' : parseInt(value, 10),
                                                    }));
                                                }
                                            }}
                                            onPaste={(e) => {
                                                if (!/^\d+$/.test(e.clipboardData.getData('Text'))) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Total Years Experience</th>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={globalCandidateSettings?.totalYearsExprience || '0'}
                                            readOnly
                                            plaintext
                                        />
                                    </td>
                                </tr>

                            </tbody>
                        </Table>


                    ) : (
                        <p>Loading...</p>
                    )}
                    <p className="mt-3 fw-bold">
                        Total applications that {selectedUserName} can apply: {totalApplications}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSaveChanges}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>

            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </DashboardLayout>
    );
};

export default GlobalSettings;
